import * as React from "react";
import { SortTableProvider, TabContent, TabLink, TabPanel, Tabs } from "soprasteria-ui-library";
import { CareAreaTab } from "./CareArea/CareAreaTab";
import { RoleGroupTab } from "./RoleGroup/RoleGroupTab";
import { IClinicTab } from "../../../../models/IClinic";
import { CarePerformerRequestTab } from "./CarePerformerRequest/CarePerformerRequestTab";
import { OrganisationTabs } from "../../Organisation/Tabs/OrganisationTabs";
import { CarePerformerTab } from "./CarePerformer/CarePerformerTab";

interface IProps {
    clinicId: number;
    selectedTab: IClinicTab | undefined;
    onTabSubmit: (message: string, tab: IClinicTab) => void;
}

export const ClinicTabs: React.FC<IProps> = ({ clinicId, selectedTab, onTabSubmit }) => {
    const careAreaTabSelected = selectedTab === undefined || selectedTab === IClinicTab.careArea;
    const roleGroupTabSelected = selectedTab === IClinicTab.roleGroup;
    const carePerformerTabSelected = selectedTab === IClinicTab.carePerformer;
    const carePerformerRequestTabSelected = selectedTab === IClinicTab.carePerformerRequest;

    return (
        <section>
            <Tabs>
                <TabLink href="careAreas" id="careAreaTab" text="Vårdområden" selected={careAreaTabSelected} />
                <TabLink href="roleGroups" id="roleGroupTab" text="Rollgrupper" selected={roleGroupTabSelected} />
                <TabLink href="carePerformers" id="carePerformerTab" text="Behandlare" selected={carePerformerTabSelected} />
                <TabLink href="carePerformerRequests" id="carePerformerRequestTab" text="Ansökningar behandlare" selected={carePerformerRequestTabSelected} />
            </Tabs>
            <TabContent>
                <TabPanel id="careAreas" ariaLabelledBy="careAreaTab" selected={careAreaTabSelected}>
                    <SortTableProvider>
                        <CareAreaTab clinicId={clinicId} />
                    </SortTableProvider>
                </TabPanel>
                <TabPanel id="roleGroups" ariaLabelledBy="roleGroupTab" selected={roleGroupTabSelected}>
                    <SortTableProvider>
                        <RoleGroupTab clinicId={clinicId} onRoleGroupSubmit={(message) => onTabSubmit(message, IClinicTab.roleGroup)} />
                    </SortTableProvider>
                </TabPanel>
                <TabPanel id="carePerformers" ariaLabelledBy="carePerformerTab" selected={carePerformerTabSelected}>
                    <SortTableProvider>
                        <CarePerformerTab clinicId={clinicId} onCarePerformerSubmit={(message) => onTabSubmit(message, IClinicTab.carePerformer)} />
                    </SortTableProvider>
                </TabPanel>
                <TabPanel id="carePerformerRequests" ariaLabelledBy="carePerformerRequestTab" selected={carePerformerRequestTabSelected}>
                    <SortTableProvider>
                        <CarePerformerRequestTab clinicId={clinicId} onCarePerformerRequestSubmit={(message) => onTabSubmit(message, IClinicTab.carePerformerRequest)} />
                    </SortTableProvider>
                </TabPanel>
            </TabContent>
        </section>
    )
}
